<template>
  <div class="main-info">
    <div class="info-top">
      <div class="info-details">
        <div class="info-english">{{ manifestoDetails.englishTitle }}</div>
        <div class="info-chinese">{{ manifestoDetails.title }}</div>
        <div class="info-top-txt" v-html="manifestoDetails.introduction"></div>
      </div>
      <div class="info-top-img">
        <imgContainer :src="manifestoDetails.rightImg" />
      </div>
    </div>
    <div class="info-bottom">
      <div class="info-bottom-img">
        <imgContainer :src="manifestoDetails.leftImg" />
      </div>
      <div class="info-bottom-txt" v-html="manifestoDetails.manifesto"></div>
    </div>
  </div>
</template>

<script setup>
import {defineProps} from "vue";
import imgContainer from '@/components/imgContainer/index.vue'

let prop = defineProps({
  manifestoDetails: {
    type: Object,
    default: () => {
    },
  }
})
</script>

<style lang="scss" scoped>
.main-info {
  width: 1200px;
  margin: 70px auto 0 auto;
}

.info-details {
  flex: 1;
}

.info-top {
  display: flex;

  :deep(td) {
    border-width: 0 !important;
    border-style: none !important;
  }

  :deep(img) {
    width: 100%;
  }
}

.info-english, .info-chinese {
  font-weight: bold;
  font-size: 28px;
  color: #242424;
  text-align: right;
}

.info-top-txt {
  margin-top: 14px;
}

.info-top-img {
  margin-left: 40px;
  width: 460px;
  height: 300px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.info-bottom {
  margin-top: 30px;
  display: flex;
}

.info-bottom-img {
  width: 460px;
  height: 300px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.info-bottom-txt {
  margin-left: 205px;
  line-height: 35px;
  flex: 1;
}

.info-chinese {
  margin-top: 6px;
}
</style>
